
import React from "react";

const Spinner =() =>{
  return (
    <div className="swapping-squares-spinner" >
  <div className="square"></div>
  <div className="square"></div>
  <div className="square"></div>
  <div className="square"></div>
</div>
  )
}

export default Spinner